import { Outlet } from "@tanstack/react-router";
import type { ReactNode } from "react";
import { Suspense } from "react";
import { IntroHold } from "./components/loader/index.js";
import { Skeleton } from "./components/skeleton.js";

/*
 * The frame a signed-in screen sits in: the routed screen itself, and the
 * notice that stands in for one. Out of app.tsx so that file stays one idea.
 */

/** The routed screen, holding a skeleton while its code is still arriving. */
export function Screen() {
  return (
    <Suspense
      fallback={
        <div className="page">
          {/* Keeps an arriving intro up until the first screen is drawn; never
              starts one, so moving between pages does not replay it. */}
          <IntroHold kind="page" />
          <div className="container">
            <Skeleton shape="report" label="Loading this page" />
          </div>
        </div>
      }
    >
      <Outlet />
    </Suspense>
  );
}

export function Notice({
  children,
  tone,
}: {
  readonly children: ReactNode;
  readonly tone?: "error";
}) {
  return (
    <div className="page">
      <div className="container narrow">
        <div className={tone === "error" ? "notice notice-error" : "notice"}>
          {children}
        </div>
      </div>
    </div>
  );
}
